import Vue from 'vue'
import zenscroll from 'zenscroll'
zenscroll.setup(null, 100) // offset top fixed banner


const delayed = []
const paused = {}
let running = false
const timers = {}


// utilities
export default {

  /**
   *
   * @param  {} args.targetElementId
   * @return {}
   */
  scrollTo(args) {
    console.log('scrolling', args)
    if (args.targetElementId) {

      setTimeout(() => {
        zenscroll.to(document.getElementById(args.targetElementId), 1000)
      }, 200)

    }

    // if (args.y) {
    //   console.log('scrolling to Y', args.y)
    //   window.scrollTo(0,0)
      // setTimeout(() => {
      //   zenscroll.toY(args.y, 1000)
      // }, 200)
    // }
    // setTimeout(() => {
    //   zenscroll.toY(document.body.scrollHeight, 1000)
    // }, 200)
  },

  delay(name, fnc, time) {
    if (delayed.indexOf(name) == -1) {
      delayed.push(name);

      setTimeout(function () {
        fnc();
        delayed.splice(delayed.indexOf(name), 1);
      }, time);
    }
  },

  // Method will run the callback method in case it wasn't updated
  onPause(name, fnc, timeout, pld) {
    let newRunTime = Date.now() + (timeout) // wait for some time
    if (!paused[name]) {
      paused[name] = {runAt: newRunTime, callBack: fnc, pld: pld}
      this.checkRunable()
    } else {
      paused[name].runAt = newRunTime
      paused[name].callBack = fnc
    }
  },
  checkRunable() {
    if (running) {return}
    running = true
    this.runPaused()
  },
  runPaused() {
    let pausedRequests = Object.keys(paused), that = this
    pausedRequests.forEach(requestName => {
      let req = paused[requestName]
      if (Date.now() > req.runAt) {
        try {
          if (req.pld) {
            req.callBack(req.pld)
          } else {
            req.callBack()
          }
        } catch(e) {
          console.error('ERROR executing paused function', e)
        }

        delete paused[requestName]
      }
    })
    if (Object.keys(paused).length > 0) {
      setTimeout(function () {
        that.runPaused()
      }, 1000);
    } else {
      running = false
    }
  },

  setTimer(name, fn, delay) {
    console.log('>', name, delay, this)
    timers[name] = {
      run: fn,
      delay: delay,
      timeToLive: (new Date()).addSeconds(delay)
    }
    console.log('Added timer', new Date(), timers[name])
    this.checkTimers()
  },
  stopTimer(name) {
    delete timers[name]
  },
  checkTimers() {
    let timerNames = Object.keys(timers)
    timerNames.forEach(tName => {
      if (timers[tName].timeToLive < (new Date())) {
        // Set new time
        timers[tName].timeToLive = (new Date()).addSeconds(timers[tName].delay)

        // execute
        timers[tName].run()
      }
    })
    if (Object.keys(timers).length > 0) {
      setTimeout(() => {this.checkTimers()}, 1000);
    }
  },

  // returns map of key : value from json object
  getMap(o) {
    var result = this.getObjectKeyValues(o,'')
    return result
  },

  getObjectKeyValues(o,r) {
    if (r != '') {r = r + '.'}
    var res = [], keys = Object.keys(o)
    for (var i=0; i < keys.length; i++) {
      var k = keys[i]
      if (typeof o[k] === 'object') {
        var sr = this.getObjectKeyValues(o[k],r + k)
        var srk = Object.keys(sr)
        for (var j=0;j<srk.length;j++) {
          res[srk[j]] = sr[srk[j]]
        }
      } else {
        res[r + k] = o[k]
      }
    }
    return res
  },

  // Returns the map as an object
  getObj(m) {
    return this.processMap(m, {})
  },

  processMap(m,o) {
    var mKeys = Object.keys(m)
    for (var i=0;i<mKeys.length;i++) {
      this.putToObject(o, mKeys[i], m[mKeys[i]])
    }
    return o
  },

  putToObject(o, p, v) {
    if (p.indexOf('.') > 0) {
      var oPath = p.split('.')
      var root = oPath.splice(0,1)
      if (o[root] === undefined) {
        o[root] = {}
      }
      this.putToObject(o[root], oPath.join('.'), v)
    } else {
      o[p] = v
    }
  },

  transiteObjs(a,b) {
    var aKeys = Object.keys(a)
    for (var i = 0; i < aKeys.length; i++) {
      if (Array.isArray(a[aKeys[i]])) {
        a[aKeys[i]].splice(0)
        for (var a = 0; a < b[aKeys[i]].length; a++) {
          a[aKeys[i]].push(b[aKeys[i]][a])
        }
      } else if (a[aKeys[i]] !== null && typeof a[aKeys[i]] === 'object') {
        this.transiteObjs(a[aKeys[i]], b[aKeys[i]])
      } else {
        a[aKeys[i]] = b[aKeys[i]]
      }
    }
  },

  clone(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = this.clone(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
        }
        return copy;
    }
  },

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
  },

  setCookie(cname, cvalue, exdays) {
    if (!exdays) {
      exdays = 1
    }
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";samesite;path=/";
  },

  removeCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == -1) {

          document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;samesite;path=/";
        }
    }
  },

  isSlotAvailable(lastSlot, shopData) {
    // let tomorrow = (new Date()).addDays(1).yyyymmdd()
    // if (lastSlot.mark.substring(0,8) == tomorrow) {
    //   let hm = this.getPlanCloseTime(lastSlot, shopData)
    //   let closingTime = new Date()
    //   closingTime.setHours(hm[0])
    //   closingTime.setMinutes(hm[1])
    //   closingTime.setSeconds(0)
    //
    //   if (closingTime < (new Date())) {
    //     allSlotsDisable = true
    //   }
    // }
  },
  getPlanCloseTime(plan, shopData) {
    let hm = []
    if (shopData.slotConfig.nextDayOrderAt == 'eols') { // End Of Last Slot
      // Find the last possible time. The slots are sorted in that manner
      // the first or the last one tell the latest time.
      if (plan.slots[0].to > plan.slots[plan.slots.length - 1].to) {
        // The first slot tells the latest time
        hm = plan.slots[0].to.split(':')
      } else {
        hm = plan.slots[plan.slots.length - 1].to.split(':')
      }

    } else {
      // The exact time for next day delivery stop is configured
      hm = shopData.slotConfig.nextDayOrderAt.split(':')
    }
    return hm
  },

  plainText(text) {
    const accents    = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËĚèéêëěðČÇçčÐĎďÌÍÎÏìíîïŤťÙÚÛŮÜùůúûüÑñŠšŸÿýŽžŘř';
    const accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEEeeeeeeCCccDDdIIIIiiiiTtUUUUUuuuuuNnSsYyyZzRr";
    let result = text.toLowerCase().split('');
    let strLen = result.length;
    let i, x;
    for (i = 0; i < strLen; i++) {
      if ((x = accents.indexOf(result[i])) != -1) {
        result[i] = accentsOut[x];
      }
    }
    result = result.join('');

    result = result.replace(/[\W]/g,'-');
    // console.log('Sluged', result)
    return result
  },

  hasJsonStructure(str) {
    if (typeof str !== 'string') return false;
    try {
        const result = JSON.parse(str);
        const type = Object.prototype.toString.call(result);
        return type === '[object Object]'
            || type === '[object Array]';
    } catch (err) {
        return false;
    }
  }

}
